<div class="vehicle-image-container">
  <img class="vehicle-image" [src]="vehicleImage" (error)="setVehicleImageDefault()"
    [ngClass]="{'mb-4': showGrade, 'centered': isStartPurchase}" alt="Dismiss modal" />
  <div class="grade-stamp" *ngIf="showGrade">
    <span class="grade-stamp-box" [ngClass]="{'grade-stamp-box-salvaged': hasSalvage}"></span>
    <span class="grade-stamp-text" [ngClass]="{'grade-stamp-text-salvaged': hasSalvage}">GRADE {{ selectedGrade }}</span>
  </div>
</div>
